import {
  WEBPAY_TOKEN,
  SAVE_WEBPAY_DATA,
  SET_SPINNER
} from './types';

const initialState = {
  webpayToken: {},
  webpayData: {},
  spinner: false,
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case WEBPAY_TOKEN:
      return { ...state, webpayToken: payload };
    case SAVE_WEBPAY_DATA:
      return { ...state, webpayData: payload };
    case SET_SPINNER:
      return { ...state, spinner: payload };
    default:
      return state;
  }
};